import React, { FunctionComponent, useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Card, CardContent, Grid, Switch, Typography } from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { api } from "../../../api";
import { SnackBar } from "../../SnackBar";
import { useServiceStyles } from "../useServiceStyles";

type StoreServiceProps = {
  serviceList: Array<object>;
  getServiceData: () => void;
};

export const StoreServices: FunctionComponent<StoreServiceProps> = ({
  serviceList,
  getServiceData
}) => {
  const classes = useServiceStyles();
  const [statusUpdate, setStatusUpdate] = useState<string>("");
  const [snackbarColor, setSnackbarColor] = useState<string>("#d50000");

  const handleTerminalService = async (enableValue: boolean, serviceId: number) => {
    try {
      const store_code = localStorage.getItem('authStoreCode');
      const values = {
        terminal_id: null,
        store_code: store_code,
        service_id: serviceId,
        is_sync_active:
          enableValue === true ? "1" : "0",
        is_select_all: true
      };
      const result = await api.patch(
        `services/status`,
        {},
        values
      );
      setSnackbarColor("green");
      setStatusUpdate("Status updated successfully");
      getServiceData();
    } catch (error) {
      console.log(error);
      setSnackbarColor("red");
      setStatusUpdate("Something went wrong");
    }
  };

  const onCloseSnackbar = () => {
    setStatusUpdate("");
  };


  return (
    <div>
      <SnackBar
        status={statusUpdate}
        onCloseError={onCloseSnackbar}
        color={snackbarColor}
      />
      <Grid container direction="column" spacing={3}>
        <Grid item>
          <Accordion expanded={true}>
            <AccordionSummary
              className={classes.accordionStyle}
              expandIcon={<ExpandMoreIcon style={{ color: "white" }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                className={classes.serviceHeading}

              >Store-Services</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container>
                <Grid item xs={12}>
                  {serviceList.map((i: any) => (
                    <Card
                      className={classes.serviceCards}
                    >
                      <CardContent
                      >
                        <Grid container>
                          <Grid item xs={9}>
                            <Typography variant="h5">
                              {i.display_name}
                            </Typography>
                            <Typography variant="body2" color="textSecondary"
                              style={{ fontSize: "14px" }}
                            >
                              Please click the switch for enabling and disabling
                              this store service.
                                                 </Typography>

                          </Grid>
                          <Grid item xs={3}>
                            <Grid container justify="flex-end">
                              <Switch
                                checked={
                                  i.is_sync_active === "1" ? true : false
                                }
                                onClick={() => {
                                  handleTerminalService(
                                    i.is_sync_active === "1" ? false : true,
                                    i.service_id)
                                }
                                }
                                color="primary"
                                name="status"
                                inputProps={{ "aria-label": "primary checkbox" }}
                              />
                              <Typography variant="h5"
                                className={classes.switchLabels}
                              >
                                {
                                  i.is_sync_active === "1" ? "On" : "Off"
                                }
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  ))}
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>
    </div>
  );
};